import React from 'react'
import { Card, Col, Row, Statistic } from 'antd'
import {
  BarcodeOutlined,
  AppstoreOutlined,
  ToolOutlined,
  GoldOutlined,
  DollarOutlined
} from '@ant-design/icons'
import { TInventorySummary } from '../../../../utils/reportUtils'
import { textNumberFormater } from '../../../../utils'

interface InventorySummaryCardsProps {
  summary: TInventorySummary
  loading?: boolean
}

export const InventorySummaryCards: React.FC<InventorySummaryCardsProps> = ({ summary, loading = false }) => {
  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
      <Col xs={24} sm={12} md={8} lg={4.8}>
        <Card loading={loading} size="small" style={{ borderRadius: 8, borderColor: '#e8e8e8' }}>
          <Statistic
            title="Total Elementos"
            value={summary.totalElements}
            prefix={<BarcodeOutlined style={{ color: '#1890ff' }} />}
            valueStyle={{ color: '#1890ff', fontWeight: 600, fontSize: '1.4rem' }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={4.8}>
        <Card loading={loading} size="small" style={{ borderRadius: 8, borderColor: '#e8e8e8' }}>
          <Statistic
            title="Total Productos"
            value={summary.totalProducts}
            prefix={<AppstoreOutlined style={{ color: '#52c41a' }} />}
            valueStyle={{ color: '#52c41a', fontWeight: 600, fontSize: '1.4rem' }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={4.8}>
        <Card loading={loading} size="small" style={{ borderRadius: 8, borderColor: '#e8e8e8' }}>
          <Statistic
            title="Total Servicios"
            value={summary.totalServices}
            prefix={<ToolOutlined style={{ color: '#fa8c16' }} />}
            valueStyle={{ color: '#fa8c16', fontWeight: 600, fontSize: '1.4rem' }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={4.8}>
        <Card loading={loading} size="small" style={{ borderRadius: 8, borderColor: '#e8e8e8' }}>
          <Statistic
            title="Existencias Totales"
            value={summary.totalInventoryQuantity}
            prefix={<GoldOutlined style={{ color: '#722ed1' }} />}
            valueStyle={{ color: '#722ed1', fontWeight: 600, fontSize: '1.4rem' }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={4.8}>
        <Card loading={loading} size="small" style={{ borderRadius: 8, borderColor: '#e8e8e8' }}>
          <Statistic
            title="Valoración Costo Total"
            value={summary.totalCostValuation}
            formatter={(val) => `$ ${textNumberFormater(Number(val))}`}
            prefix={<DollarOutlined style={{ color: '#13c2c2' }} />}
            valueStyle={{ color: '#13c2c2', fontWeight: 600, fontSize: '1.3rem' }}
          />
        </Card>
      </Col>
    </Row>
  )
}

export default InventorySummaryCards
